import React from 'react';
import { Routes, Route } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import { authProtectedRoutes, adminRoutes, sellerRoutes, sharedAuthRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from './AuthProtected';
import { getUserRole } from "../helpers/role_helper";
import { useProfile } from "../Components/Hooks/UserHooks";

const Index = () => {
    const { userProfile } = useProfile();
    const userRole = getUserRole(userProfile);

    // Filter routes based on user role
    const getFilteredRoutes = () => {
        if (!userRole) return [];
        
        if (userRole === "admin") {
            return adminRoutes;
        } else if (userRole === "seller") {
            return sellerRoutes;
        }
        return [];
    };

    const filteredRoutes = getFilteredRoutes();

    return (
        <React.Fragment>
            <Routes>
                <Route>
                    {publicRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <NonAuthLayout>
                                    {route.component}
                                </NonAuthLayout>
                            }
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>

                <Route>
                    {/* Shared (admin + seller) — register before role-specific routes */}
                    {sharedAuthRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <AuthProtected allowedRoles={["admin", "seller"]}>
                                    <VerticalLayout>{route.component}</VerticalLayout>
                                </AuthProtected>}
                            key={`shared-${idx}`}
                        />
                    ))}
                    {/* Admin Routes */}
                    {adminRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <AuthProtected requiredRole="admin">
                                    <VerticalLayout>{route.component}</VerticalLayout>
                                </AuthProtected>}
                            key={`admin-${idx}`}
                            exact={true}
                        />
                    ))}
                    
                    {/* Seller Routes */}
                    {sellerRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <AuthProtected requiredRole="seller">
                                    <VerticalLayout>{route.component}</VerticalLayout>
                                </AuthProtected>}
                            key={`seller-${idx}`}
                            exact={true}
                        />
                    ))}
                </Route>
            </Routes>
        </React.Fragment>
    );
};

export default Index;